export const DATE_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm';
export const START_END_MIN_DIFF = 30;
export const ITEM_NAME_LIST_LENGTH = 3;
export const DEFAULT_DATE_PLACEHOLDER = 'YYYY-MM-DD';
export const FULL_TIME_FORMAT = 'HH:mm:ss';





// WEBPACK FOOTER //
// ./src/components/UI/Form/constants.js